import { useState } from "react";
import { Mail, X } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Bandeau « confirme ton adresse » affiché aux utilisateurs connectés dont
 * l'email n'est pas encore vérifié. N'apparaît pas pour les invités, les
 * comptes vérifiés, ou après que l'utilisateur l'a masqué pour la session.
 */
const EmailVerifyBanner = () => {
    const { status, user } = useAuth();
    const [sent, setSent] = useState(false);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const [hidden, setHidden] = useState(false);

    if (status !== "authed" || !user || user.email_verified || hidden) return null;

    const resend = async () => {
        setBusy(true);
        setErr("");
        try {
            await api.post("/auth/resend-verification");
            setSent(true);
        } catch (e) {
            setErr(formatApiError(e, "Envoi impossible."));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div
            data-testid="verify-banner"
            className="bg-terracotta/10 border-b border-terracotta/30 text-ink"
        >
            <div className="container-edit py-2.5 flex items-center gap-3 text-sm">
                <Mail className="w-4 h-4 text-terracotta shrink-0" />
                {sent ? (
                    <span>
                        Email de confirmation renvoyé à{" "}
                        <strong>{user.email}</strong>. Pense à regarder dans tes spams.
                    </span>
                ) : (
                    <span>
                        Confirme ton adresse <strong>{user.email}</strong> : clique le lien
                        qu&apos;on vient de t&apos;envoyer par email.
                        {err ? <span className="text-destructive"> {err}</span> : null}
                    </span>
                )}
                {!sent ? (
                    <button
                        onClick={resend}
                        disabled={busy}
                        data-testid="verify-resend"
                        className="ml-auto text-terracotta hover:text-ink font-medium underline-offset-2 hover:underline shrink-0"
                    >
                        {busy ? "Envoi…" : "Renvoyer l'email"}
                    </button>
                ) : null}
                <button
                    onClick={() => setHidden(true)}
                    aria-label="Masquer"
                    data-testid="verify-banner-close"
                    className={`btn-ghost p-1 shrink-0 ${sent ? "ml-auto" : ""}`}
                >
                    <X className="w-3.5 h-3.5" />
                </button>
            </div>
        </div>
    );
};

export default EmailVerifyBanner;
